import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { SimpleFastEasyElement } from '@modules/Landing/Shared/Ui/SimpleFastEasyElement/SimpleFastEasyElement';
import { LandingTitle } from '@modules/Landing/Shared/Ui/LandingTitle/LandingTitle';
import css from './LandingHeaderWelcomePart.module.css';
import { CheckedQuestions } from '@modules/Landing/Shared/Ui/CheckedQuestions/CheckedQuestions';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@configs/AppRoutes';

export const LandingHeaderWelcomePart: React.FC = () => {
    const navigate = useNavigate();
    const handleNavigateToTemplatesPage = () => {
        navigate(ROUTES.TEMPLATES);
    };
    return (
        <section className={css.section}>
            <SimpleFastEasyElement />
            <LandingTitle />
            <CheckedQuestions />
            <BasicButton
                extraClassName={css.btn}
                onClick={handleNavigateToTemplatesPage}
            >
                Try our templates
            </BasicButton>
        </section>
    );
};
